import { UserMenu } from './UserMenu'
import { NotificationBell } from './NotificationBell'
import { ChatBell } from './ChatBell'

export function TopBar() {
  return (
    <header className="h-16 bg-white border-b border-gray-200 sticky top-0 z-40 shrink-0">
      <div className="h-full px-6 flex items-center justify-end gap-2">
        {/* Chat messages */}
        <ChatBell />

        {/* Notifications */}
        <NotificationBell />

        {/* User Menu */}
        <UserMenu />
      </div>
    </header>
  )
}
